export default {
    'external-account': "Supplier",
    'generate-buy-invoice': "Generate Purchase Invoice",
    'fill-invoice-data': "Fill Invoice Data",
    'choose-invoice-entries': "Choose Invoice Items",
    'order-no': "Order Number",
    'generate-invoice': "Generate Invoice",
    'invoice-generated': "Purchase Invoice Generated",
    'show-invoice': "Show Invoice",
    "order-updated": "Order data updated successfully",
    "order-delete-alert": "Are you sure you want to delete the order?",
    "order-delete": "Order Delete",
    "order-date": "Order Date",
    "order-status": "Order Status",
    'not-defined': "Not Defined",
    'in-progress': "In Progress",
    'done': "Done"

  };
  